/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

function TagSkeleton(_ref) {
  let {
    className,
    size,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const tagClasses = cx(`${prefix}--tag`, `${prefix}--skeleton`, className, {
    [`${prefix}--tag--${size}`]: size,
    // TODO: V12 - Remove this class
    [`${prefix}--layout--size-${size}`]: size
  });
  return /*#__PURE__*/React__default.createElement("span", _extends({
    className: tagClasses
  }, rest));
}
TagSkeleton.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string,
  /**
   * Specify the size of the Tag. Currently supports either `sm` or
   * default sizes.
   */
  size: PropTypes.oneOf(['sm'])
};

export { TagSkeleton, TagSkeleton as default };
